import { isEmpty } from 'lodash';
import Modelo from './Modelo';

export const CAMPOS_ESTRUCTURA = ['anno_lectivo', 'ensennanza', 'nivel', 'curso', 'modalidad', 'grupo'];

/**
 * Se trata de un Path de la estructura escolar. Un path es un hash con cada parte de la
 * estructura escolar a la que hace referencia. Por ejemplo:
* {
  "anno_lectivo": {
      "type": "anno_lectivo",
      "id": 1029,
      "anno": "2024-2025",
      "nombre": "2024-2025",
  "nivel": {
      "type": "nivel",
      "id": 4728,
      "nombre": "Mecanizado",
      "etiqueta": "MEC",
  },
  "curso": {
      "type": "curso",
      "id": 11528,
      "codigo": "2",
      "numero": 2,
      "nombre": "2º",
  }
}
 */
export default class Path {
  constructor(pathHash, _options = {}) {
    this.pathHash = pathHash;
  }

  toHash() {
    return { ...this.pathHash };
  }

  /**
   * Devuelve el path pero en un array ordenado de menos a más relevancia (año ---> grupo)
   */
  toPathArray() {
    const res = [];
    if (!isEmpty(this.pathHash)) {
      CAMPOS_ESTRUCTURA.forEach((campo) => {
        const p = this.pathHash[campo];
        if (p) {
          res.push(new Modelo(p));
        }
      });
    }
    return res;
  }

  toPathString() {
    const pathArray = this.toPathArray();
    return pathArray.map((p) => p.label).join(' > ');
  }

  /**
   * Devuelve un hash solo con los campos con los ids:
   * { anno_lectivo_id: 111, ensennanza_id: 222 } etc
   */
  toParamIds() {
    const res = {};
    Object.entries(this.pathHash).forEach(([campo, modelo]) => {
      res[`${campo}_id`] = modelo.id;
    });

    return res;
  }
}

export function ensurePath(pathHash) {
  if (pathHash instanceof Path) {
    return pathHash;
  }
  return new Path(pathHash);
}

/*
 * Ordena una lista de paths de mayor a menor (de más reciente a más antiguo)
 */
export function ordenarPaths(listaPaths) {
  return listaPaths.sort((a, b) => {
    const nombreA = a.toPathString().toUpperCase();
    const nombreB = b.toPathString().toUpperCase();
    if (nombreA < nombreB) {
      return 1;
    }
    if (nombreA > nombreB) {
      return -1;
    }
    return 0;
  });
}
